export default __webpack_public_path__ + "static/media/logo.fcfdd782.png";